<template>
  <div class="about">
    <h1>Hola soy santi</h1>
  </div>
</template>
